import { Directive, inject, Input } from '@angular/core';
import { Table } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';
import { catchError, filter, Observable, of, Subject, switchMap, tap } from 'rxjs';

@Directive({
    standalone: true,
    selector: '[hrTable]',
})
export class HrTableDirective<TData> {

    @Input() set tableDataLoader(loader: Observable<TData>) {
        this.tableDataLoader$.next(loader);
    }
    tableDataLoader$ = new Subject<Observable<TData>>();

    listData$: Observable<TData>;
    primeNgTable: Table;

    constructor(primeNgTable: Table) {
        const translateService = inject(TranslateService);
        this.primeNgTable = primeNgTable;
        primeNgTable.rowsPerPageOptions = [10, 50, 100, 1000];
        primeNgTable.paginator = true;
        primeNgTable.rows = 10;
        primeNgTable.styleClass='p-datatable-striped';
        primeNgTable.showCurrentPageReport=true;
        primeNgTable.currentPageReportTemplate= translateService.instant('hrCommon.totalRecords') + " {totalRecords}"
        primeNgTable.dataKey='id';
        primeNgTable.selectionMode='single';

        this.listData$ = this.tableDataLoader$.pipe(filter(it=>!!it), switchMap(tableDataLoader=>{
            primeNgTable.loading = true;
            return tableDataLoader.pipe(catchError((err)=> {
                console.warn(err);
                return of(null);
            }));
        }), tap(() => {
            primeNgTable.loading = false;
        }));
    }

}
